import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

axios.defaults.withCredentials = true;
axios.defaults.baseURL = apiUrl;

export default axios;
